var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H10V10H2V2ZM2.8 2.8V4.4H4.4V2.8H2.8ZM5.2 2.8V4.4H6.8V2.8H5.2ZM7.6 2.8V4.4H9.2V2.8H7.6ZM9.2 5.2H7.6V6.8H9.2V5.2ZM9.2 7.6H7.6V9.2H9.2V7.6ZM6.8 9.2V7.6H5.2V9.2H6.8ZM4.4 9.2V7.6H2.8V9.2H4.4ZM2.8 6.8H4.4V5.2H2.8V6.8ZM5.2 5.2V6.8H6.8V5.2H5.2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridS);
export default __webpack_public_path__ + "static/media/grid-s.88d4ddb536171bcbe822ceb1860c50d6.svg";
export { ForwardRef as ReactComponent };